
import { defineComponent, PropType } from 'vue';
import { Deal, DealProduct, findProduct, priceDeal, periodWord } from '../../deals';
import { formatMoney } from '../../salesLeads';

/** Product + units + expected duration + priced lines, shared by the lead form and Create Sale. */
export default defineComponent({
  name: 'DealLines',
  props: {
    modelValue: { type: Object as PropType<Deal>, required: true },
    products: { type: Array as PropType<DealProduct[]>, default: () => [] },
    monthOptions: { type: Array as PropType<number[]>, default: () => [1, 3, 6, 12, 18, 24, 36, 48, 60] },
    hint: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'product-changed'],
  computed: {
    product(): DealProduct | null {
      return findProduct(this.products, this.modelValue.jahaji_product_id);
    },
    unitWord(): string {
      return this.product ? this.product.unit_label.toLowerCase() : 'unit';
    },
    priced(): ReturnType<typeof priceDeal> {
      return priceDeal(this.product, this.modelValue);
    },
  },
  methods: {
    money: formatMoney,
    period: periodWord,
    emit(deal: Deal) {
      this.$emit('update:modelValue', deal);
    },
    set(field: 'units' | 'contract_months', value: string) {
      this.emit({ ...this.modelValue, [field]: value });
    },
    setProduct(id: string) {
      this.emit({ ...this.modelValue, jahaji_product_id: id ? Number(id) : '', lines: {} });
      this.$emit('product-changed', id ? Number(id) : null);
    },
    setLine(chargeId: number, field: string, value: any) {
      const lines = { ...this.modelValue.lines, [chargeId]: { ...(this.modelValue.lines[chargeId] || {}), [field]: value } };
      this.emit({ ...this.modelValue, lines });
    },
  },
});
